import { InvestmentTrustType } from 'components/features/target-achievement-support/utils/type';
import { commaFormat } from 'components/features/new-report/utils/formatter';
import React from 'react';

type Props = {
  symbolCode: string;
  symbolName: string;
  basePrice: number;
  basePriceDate: Date;
  returnPercentage: number | null;
  reward: number;
  isShowTag: boolean;
  investmentTrustType: InvestmentTrustType;
  onClickDetail: () => void;
};

export const InvestmentTrustItem = ({
  symbolCode,
  symbolName,
  basePrice,
  basePriceDate,
  returnPercentage,
  isShowTag,
  reward,
  investmentTrustType,
  onClickDetail,
}: Props): React.ReactElement => {
  const isShowBasePriceAndDetail = investmentTrustType !== 'US_ETF';
  const isShowReturnAndReward = investmentTrustType === 'JP_MF';

  return (
    <>
      {isShowBasePriceAndDetail ? (
        <>
          <div
            className="rounded-lg border border-bluegray-300 bg-white grid cursor-pointer"
            style={{ gridTemplateColumns: '1fr auto' }}
            onClick={onClickDetail}>
            <div>
              <div className="flex flex-col p-4">
                <div className="flex flex-row items-center">
                  {isShowTag && (
                    <>
                      <div className="flex flex-row items-center mr-2 bg-teal-500 h-5 px-3 text-white text-1.5xs rounded-full">
                        保有中
                      </div>
                    </>
                  )}
                  <div className="mr-auto text-sm text-bluegray-500">
                    {symbolCode}
                  </div>
                </div>
                <div className="flex font-bold text-bluegray-700 text-sm mt-1">
                  {symbolName}
                </div>
                <div className="flex flex-row items-center mt-3">
                  <div className="text-sm text-bluegray-500 mr-auto">
                    基準価格({basePriceDate.getMonth() + 1}/
                    {basePriceDate.getDate()})
                  </div>
                  <div className="font-bold text-bluegray-700 flex flex-row items-baseline">
                    <div className="text-base">
                      {commaFormat(basePrice, { numberOfDecimals: 0 })}
                    </div>
                    <div className="text-xs ml-1">円</div>
                  </div>
                </div>
              </div>
              {isShowReturnAndReward && (
                <div
                  className="grid border-t border-bluegray-300"
                  style={{ gridTemplateColumns: '1fr 1fr' }}>
                  <div className="flex flex-row items-center py-3 px-4">
                    <div className="text-xs text-bluegray-500 mr-auto leading-lessTight">
                      リターン
                      <br />
                      (１年)
                    </div>
                    <div className="text-sm font-bold text-bluegray-700">
                      {returnPercentage === null
                        ? '---'
                        : commaFormat(returnPercentage, {
                            numberOfDecimals: 2,
                          })}
                      %
                    </div>
                  </div>
                  <div className="border-l border-bluegray-300 flex flex-row items-center py-3 px-4 bg-bluegray-60">
                    <div className="text-xs text-bluegray-500 mr-auto">
                      信託報酬
                    </div>
                    <div className="text-sm font-bold text-bluegray-700">
                      {commaFormat(reward, { numberOfDecimals: 3 })}%
                    </div>
                  </div>
                </div>
              )}
            </div>
            <div className="flex rounded-r-lg flex-row items-center icon-chevron-right text-2xl font-bold text-bluegray-400 bg-bluegray-60 border-l border-bluegray-300"></div>
          </div>
        </>
      ) : (
        <div
          className="rounded-lg border border-bluegray-300 bg-white grid"
          style={{ gridTemplateColumns: '1fr auto' }}>
          <div>
            <div className="flex flex-col p-4">
              <div className="flex flex-row items-center">
                {isShowTag && (
                  <>
                    <div className="flex flex-row items-center mr-2 bg-teal-500 h-5 px-3 text-white text-1.5xs rounded-full">
                      保有中
                    </div>
                  </>
                )}
                <div className="mr-auto text-sm text-bluegray-500">
                  {symbolCode}
                </div>
              </div>
              <div className="flex font-bold text-bluegray-700 text-sm mt-1">
                {symbolName}
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};
